import './App.css';

import { CookiesProvider } from 'react-cookie';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext.js';
import AboutUs from './AboutUs.js';
import Baa from './Baa.js';
import Case from './Case.js';
import Chdpp from './Chdpp.js';
import ExecuteBaa from './ExecuteBaa.js';
import ColorPaletteShowcase from './ColorPaletteShowcase.js';
import ContactUs from './ContactUs.js';
import DocumentProcessing from './DocumentProcessing';
import Home from './Home.js';
import MyCases from './MyCases.js';
import Press from './Press.js';
import PressRelease from './PressRelease.js';
import Pricing from './Pricing.js';
import Privacy from './Privacy.js';
import { AnalyticsTracker } from './analytics.js';
import ScrollToTop from './ScrollToTop.js';
import SecurityPrivacy from './SecurityPrivacy.js';
import Terms from './Terms.js';
import Register from './Register.js';
import VerifyEmail from './VerifyEmail.js';
import ForgotPassword from './ForgotPassword.js';
import ResetPassword from './ResetPassword.js';
import { useInactivityTimer } from './useInactivityTimer.js';

/**
 * Inner component that has access to Router context for useLocation hook
 */
function AppContent() {
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();

  useInactivityTimer({
    isAuthenticated,
    onLogout: () => logout(),
    location,
  });

  return (
    <>
      <ScrollToTop />
      <AnalyticsTracker />
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route exact path='/mycases' element={<MyCases />} />
        <Route exact path='/register' element={<Register />} />
        <Route exact path='/verify-email' element={<VerifyEmail />} />
        <Route exact path='/forgot-password' element={<ForgotPassword />} />
        <Route exact path='/reset-password' element={<ResetPassword />} />
        <Route exact path='/case/:caseId' element={<Case />} />
        <Route exact path='/document_processing' element={<DocumentProcessing />} />
        <Route exact path='/contact' element={<ContactUs />} />
        <Route exact path='/about' element={<AboutUs />} />
        <Route exact path='/pricing' element={<Pricing />} />
        <Route exact path='/security' element={<SecurityPrivacy />} />
        <Route exact path='/privacy' element={<Privacy />} />
        <Route exact path='/terms' element={<Terms />} />
        <Route exact path='/press' element={<Press />} />
        <Route exact path='/press/:slug' element={<PressRelease />} />
        <Route exact path='/baa' element={<Baa />} />
        <Route exact path='/execute-baa' element={<ExecuteBaa />} />
        <Route exact path='/chdpp' element={<Chdpp />} />
        <Route exact path='/color-palette-showcase' element={<ColorPaletteShowcase />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <CookiesProvider>
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </CookiesProvider>
  );
}


export default App;
